module.exports = __webpack_public_path__ + "static/media/noVideoToCodeing.7ab9658a.jpg";